import { apiClient } from "../config/api.config";
import {
  FacilityInvoice,
  InvoiceSummary,
  OpenPaymentIntent,
  PageResponse,
  PaymentInitiatedResponse,
  PaymentStatusResponse,
} from "../types/payment";

export function initiateInvoicePayment(
  invoiceId: number,
  idempotencyKey: string
): Promise<{ data: PaymentInitiatedResponse }> {
  return apiClient.request({
    method: "post",
    url: `/invoices/${invoiceId}/payments/initiate`,
    data: { idempotencyKey },
  });
}

export function getInvoicePaymentStatus(
  invoiceId: number,
  paymentIntentId: number
): Promise<{ data: PaymentStatusResponse }> {
  return apiClient.request({
    method: "get",
    url: `/invoices/${invoiceId}/payments/${paymentIntentId}/status`,
  });
}

// 204 (empty body) when the invoice has no open payment to resume.
export function getOpenInvoicePayment(
  invoiceId: number
): Promise<{ status: number; data: OpenPaymentIntent | "" | null }> {
  return apiClient.request({
    method: "get",
    url: `/invoices/${invoiceId}/payments/open`,
  });
}

export function cancelInvoicePayment(
  invoiceId: number,
  paymentIntentId: number
): Promise<{ data: PaymentStatusResponse }> {
  return apiClient.request({
    method: "post",
    url: `/invoices/${invoiceId}/payments/${paymentIntentId}/cancel`,
  });
}

export function getPendingInvoiceForFacility(
  facilityId: number
): Promise<{ data: InvoiceSummary }> {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/invoices/pending`,
  });
}

// MED-1652: the facility's licence invoices, newest first.
export function getFacilityInvoices(
  facilityId: number,
  page: number,
  size: number
): Promise<{ data: PageResponse<FacilityInvoice> }> {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/invoices`,
    params: { page, size },
  });
}
